import { gql } from '@apollo/client'

export const GET_MY_CHANNEL_FOLLOWERS = gql`
  query GetMyChannelFollowers($channelId: ID!) {
    myChannel(id: $channelId) {
      id
      followersCount
      followers {
        id
        fullName
        picture
        updatedAt
      }
    }
  }
`
